import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./css/ServiceRequestItem3.css";

const formatDateTime = (dateStr) => {
  if (!dateStr) return '';
  try {
    // Catalyst format: "2026-03-06 03:52:49:432"
    const [datePart, timePart] = dateStr.split(' ');
    const [year, month, day] = datePart.split('-');
    const [hours, minutes] = timePart.split(':');

    return `${month}/${day}/${year} ${hours}:${minutes}`;
  } catch {
    return dateStr;
  }
};

const ServiceRequestItem3 = ({
  srNo,
  description,
  machineName,
  type,
  status,
  Time,
  Name,
  Webpage,
  Recordid,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const formattedTime = formatDateTime(Time);

  const toggleExpand = () => setIsExpanded(!isExpanded);
  const navigate = useNavigate();

  const handleRowClick = () => {
    navigate(`/ServiceNotesStatus/${Recordid}`);
  };

  return (
    <>
      <tr className="sr-table-row" onClick={handleRowClick} style={{ cursor: "pointer" }}>
        <td className="Dark">
          <Link
            to={`/ServiceNotesStatus/${Recordid}`}
            onClick={(e) => e.stopPropagation()}
          >
            {srNo}
          </Link>
        </td>
        <td className="description">{description}</td>
        <td className="machinename">{machineName}</td>
        <td className="type">{type}</td>
        <td className="status-status">
          <span className="sr-status-badge">{status}</span>
        </td>
        <td className="Time">{formattedTime}</td>
        <td className="requestName">{Name}</td>
        <td className="requestWebpage">{Webpage}</td>
        <td
          className="expand-arrow"
          onClick={(e) => {
            e.stopPropagation();
            toggleExpand();
          }}
        >
          <span className="arrow-icon">{isExpanded ? "▲" : "▼"}</span>
        </td>
      </tr>
      {isExpanded && (
        <tr className="expanded-row">
          <td colSpan="9">
            <div className="expanded-content">
              <p>
                <strong>Status:</strong>{" "}
                <span className="sr-status-badge">{status}</span>
              </p>
              <p>
                <strong>Time:</strong> {formattedTime}
              </p>
              <p>
                <strong>Name:</strong> {Name}
              </p>
              <p>
                <strong>Webpage:</strong> {Webpage}
              </p>
            </div>
          </td>
        </tr>
      )}
    </>
  );
};

export default ServiceRequestItem3;
